﻿export default {
        showcaseOrder: {
            id: '',
            createdAt:'',
            addressLine: '',
            text: '',
            showcaseObjectType:''
        },
};
